const DATA_ATTR    = 'data-blog-card';
const CLASS_PREFIX = 'blog-card';


export function blogCard(container) {

}
